export default "https://api.mapbox.com/styles/v1/pieterfabry/ck48sira20xsf1csyy91ebawn/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoicGlldGVyZmFicnkiLCJhIjoiY2s0OHFzdWt5MThyZTNscTc4eGx4dDAzcSJ9.DL2Pu-HvKhK6A8RGuMDiOA";
